import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Card from "../../Elements/Card";
import Footer, { FooterTab, MobileFooter } from "../GreenHome/Footer";
import useFindDevice from "../CustomHooks/FindDevice";
import Navbar from "../../_V2/Pages/RoundToJoin/navbar";
import { pnpLogo } from "../../_V2/Asserts";

function PrivacyPolicy() {
  const navigate = useNavigate();
  const { isMob, isTab, isLogedIn } = useFindDevice();
  const [userInfo, setUserInfo] = useState(null);
  const [selectedNav, setSelectedNav] = useState("");
  const [dropdownMenuOpen, setDropdownMenuOpen] = useState(false);
  const [otherMenusOpen, setOtherMenusOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("userInfo");
    if (storedUserInfo) {
      try {
        debugger
        const parsedUserInfo = JSON.parse(storedUserInfo);
        setUserInfo(parsedUserInfo?.userLogedIn);
      } catch (error) {
        setUserInfo(null);
      }
    } else {
      setUserInfo(null);
    }
  }, []);

  const redirectToLogin = () => {
    navigate("/login");
  };

  const redirectToRegister = () => {
    navigate("/signup");
  };

  const redirectHome = () => {
    navigate("/");
  };

  const storedUserInfo = JSON.parse(localStorage.getItem("userInfo"));
  return (
    <>
      {
        storedUserInfo?.email && <Navbar
          setDropdownOpen={setDropdownMenuOpen}
          setSelectedNav={setSelectedNav}
          selectedNav={selectedNav}
          setMobileMenuOpen={setMobileMenuOpen}
          setDropdownPos={setDropdownPos}
          dropdownPos={dropdownPos}
          dropdownOpen={dropdownMenuOpen}
          mobileMenuOpen={mobileMenuOpen}
          setOtherMenusOpen={setOtherMenusOpen}
          otherMenusOpen={otherMenusOpen}
        />
      }


      {isMob === true ? (
        <div
          className={`overflow-auto font-interFont ${isMob
            ? "bg-[url('../public/v2/images/bg/auth-bg-mobile.png')]"
            : "bg-[url('../public/v2/images/bg/auth-bg.png')]"
            } bg-cover h-[100vh]`}
        >
          <div className="h-[100vh] w-full px-2 py-5 font-Inter">
            {!storedUserInfo?.email && (
              <div className="flex w-full p-2 justify-between items-center border-b border-[#D3D3D31F] mx-auto">
                <div className="flex-shrink-0">
                  <img 
                    src={pnpLogo} 
                    alt="pickNdPrizes" 
                    onClick={redirectHome}
                    className="h-12 w-auto cursor-pointer"
                  />
                </div>
                <div className="text-[10px] font-[400] font-roboto flex gap-1 items-center flex-shrink-0">
                  <button
                    className="bg-[#00C05B] text-[8px] py-[6px] px-[8px] rounded-[20px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToLogin}
                  >
                    Login
                  </button>

                  <button
                    className="bg-[#007FFF] text-[8px] py-[6px] px-[6px] rounded-[20px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToRegister}
                  >
                    Sign Up For Free
                  </button>
                </div>
              </div>
            )}
            <div>
              <div className={`px-2 privacy-top ${storedUserInfo?.email ? 'mt-24' : 'mt-2'}`}>
                <h2 className="text-[#FFFFFF] text-[24px] text-center font-semibold ">
                  Privacy & Cookie Policy
                </h2>
              </div>

              {/* <Card className="mx-2 h-[67.6vh] overflow-auto px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <p className="text-[12px] mt-[2%] text-[#0000005A] font-semibold">
                  Welcome to SportsPik! We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your data when you interact with our website and services. SportsPik is committed to protecting your privacy policy. Please review the following detailed information about your privacy rights and our data practices.
                </p>
                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  1. Information We Collect:
                </h4>
                <p className="text-[12px] mt-[2%] text-[#0000005A] font-semibold">
                  When you create an account on SportsPik, we may collect various types of personal information, including your name, email address, date of birth, payment details, and any other information necessary for account setup and participation in prediction games.
                </p>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  Additionally, we automatically gather non-personal information such as your IP address, device type, browser information, and cookies to enhance user experience, analyze trends, and ensure the security of our platform.
                </p>

                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  2. Use of Your Information:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  2·1 Your personal information is primarily used to manage your account, process payments, facilitate game participation, communicate important messages.
                </p>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  2.2 Non-personal information is utilised for statistical analysis, website optimization, security monitoring, and customization of content to better meet your preferences and needs.
                </p>

                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  3. Data Security Measures:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  3·1 SportsPik implements robust security measures to protect your personal data from unauthorized access, disclosure, alteration, or destruction. Your information is stored securely and accessed only by authorized personnel for legitimate business purposes.
                </p>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  3·2 All payment transactions are encrypted and processed through reputable payment gateways to ensure the confidentiality and integrity of your financial details.
                </p>

                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  4. Sharing of Information:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  4·1 SportsPik do not sell, trade, or rent your personal information to third parties for marketing purposes. However, we may share your data with trusted service providers, partners, or affiliates who assist us in delivering our services, processing payments, or improving user experience.
                </p>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  4·2 These third parties are contractually obligated to maintain the confidentiality of your information and adhere to data protection regulations.
                </p>

                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  5. Use of Cookies and Tracking Technologies:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  5·1  At sportspik.com (“Site”), we use cookies to make your experience seamless when you visit our website. Cookies help us:
                </p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold">
                  <li>Remember who you are when you come back</li>
                  <li>Improve how our site works</li>
                  <li>Make sure everything runs smoothly</li>
                  <li>Show you content that is more relatable to you</li>
                </ul>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  5.2 What are cookies? <br />
                  Cookies are small text files stored on your device (like your phone or computer) when you visit a website. They don’t harm your device and can’t see your personal information, but they help the website work properly and give you a more personalized experience.
                </p>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">Types of cookies we use:</p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold">
                  <li>
                    <strong>Essential cookies:</strong> These are needed for the site to work (like logging in or making a payment).
                  </li>
                  <li>
                    <strong>Performance cookies:</strong> These help us understand how players use the site so we can make it better.
                  </li>
                  <li>
                    <strong>Functionality cookies:</strong> These remember your settings, like your language or region.
                  </li>
                  <li>
                    <strong>Targeting cookies:</strong> These help us show you more relevant content and may be shared with our advertising partners.
                  </li>
                </ul>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  Some cookies may also be placed by third-party services we use (like analytics or ad networks). We don’t control those cookies, but we aim to work only with trusted partners.
                </p>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  5.3 Controlling cookies:

                  You can control or delete cookies anytime in your browser settings. If you block some cookies, parts of our site might not work properly. Helpful links:
                </p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold">
                  <li>Your Online Choices</li>
                  <li>All About Cookies</li>
                </ul>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  By continuing to use our site, you agree to our use of cookies. Unless required, all non-essential cookies automatically expire after 30 days.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  Got questions?
                </p>
                <p>
                  You can contact us at: support@sportspik.com.
                </p>


                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  6. Data Retention:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  6·1 SportsPik retain your personal information only for as long as necessary to fulfil the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law. The criteria used to determine the appropriate retention period include the duration of your account and our legal obligations.
                </p>

                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  7. User Rights:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  7.1 You have certain rights regarding your personal data, including the right to access, rectify, delete, or restrict the processing of your information. You may also have the right to data portability and the right to object to processing under certain circumstances.
                </p>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  7·2  To exercise these rights or for any inquiries regarding your personal data, please contact us using the information provided in the "Contact Us" section below.
                </p>

                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  8. Data Transfer:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  8·1  Your personal data may be transferred to and processed in countries other than your own, where data protection laws may differ. When SportsPik transfers your information to third parties or service providers outside your country, SportsPik takes appropriate safeguards to ensure that your data is adequately protected in accordance with applicable data protection laws.
                </p>

                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  9. Children's Privacy:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  9.1 SportsPik only permits players who are 18 years of age or older. Access to the platform is not granted to children’s and individuals under the age of 18.
                </p>

                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  10. Legal Basis for Processing:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  10·1 SportsPik relies on various legal bases to process your personal data, including consent, contract performance, legitimate interests, and compliance with legal obligations. We may process your information for the purposes stated in this Privacy Policy based on one or more of these legal grounds.
                </p>

                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  11. Data Breach Notification:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  11·1 In the event of a data breach that may compromise the security of your personal information, SportsPik will notify you and the relevant authorities as required by applicable law. We will also take appropriate measures to mitigate the impact of the breach and prevent future incidents.
                </p>
                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  12. Third-Party Links and Services:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  12·1 Our website may contain links to third-party websites or services for your convenience. Please be aware that we are not responsible for the privacy practices or content of these external sites. SportsPik recommends reviewing the privacy policies of these third parties before engaging with their services.
                </p>
                <h4 className="text-[12px] mt-[3%] text-[#000000] font-semibold">
                  13. Updates to Privacy & Cookie Policy:
                </h4>
                <p className="text-[12px] text-[#0000005A] font-semibold">
                  13·1  SportsPik reserves the right to update and revise this Privacy Policy as needed to reflect changes in our data practices, legal requirements, or business operations. Any modifications will be communicated to you through our website or via email.
                </p>
              </Card> */}
              <Card className="mx-2 h-[67.6vh] overflow-auto px-4 pt-8 pb-8 flex flex-col justify-between w-[calc(100%-1rem)] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <p className="md:text-[17px] mt-[2%] text-[#0000005A] font-semibold">
                  Welcome to SportsPik! We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your data when you interact with our website and services. SportsPik is committed to protecting your privacy policy. Please review the following detailed information about your privacy rights and our data practices.
                </p>
                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  1. Information We Collect:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">1.1</strong> When you create an account on SportsPik, we may collect various types of personal information, including your name, email address, date of birth, payment details, and any other information necessary for account setup and participation in prediction games.
                </p>
                <p className="md:text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">1.2</strong> Additionally, we automatically gather non-personal information such as your IP address, device type, browser information, and cookies to enhance user experience, analyze trends, and ensure the security of our platform.
                </p>

                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  2. Use of Your Information:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">2·1</strong> Your personal information is primarily used to manage your account, process payments, facilitate game participation, communicate important messages.
                </p>
                <p className="md:text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">2.2</strong> Non-personal information is utilised for statistical analysis, website optimization, security monitoring, and customization of content to better meet your preferences and needs.
                </p>

                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  3. Data Security Measures:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">3·1</strong> SportsPik implements robust security measures to protect your personal data from unauthorized access, disclosure, alteration, or destruction. Your information is stored securely and accessed only by authorized personnel for legitimate business purposes.
                </p>
                <p className="md:text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">3·2</strong> All payment transactions are encrypted and processed through reputable payment gateways to ensure the confidentiality and integrity of your financial details.
                </p>

                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  4. Sharing of Information:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4·1</strong> SportsPik do not sell, trade, or rent your personal information to third parties for marketing purposes. However, we may share your data with trusted service providers, partners, or affiliates who assist us in delivering our services, processing payments, or improving user experience.
                </p>
                <p className="md:text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">4·2</strong> These third parties are contractually obligated to maintain the confidentiality of your information and adhere to data protection regulations.
                </p>

                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  5. Use of Cookies and Tracking Technologies:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">5.1</strong> At sportspik.com (“Site”), we use cookies to make your experience seamless when you visit our website. Cookies help us:
                </p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold marker:text-black">
                  <li>Remember who you are when you come back</li>
                  <li>Improve how our site works</li>
                  <li>Make sure everything runs smoothly</li>
                  <li>Show you content that is more relatable to you</li>
                </ul>

                <p className="md:text-[17px] text-[#0000005A] font-semibold mt-[2%] pt-3">
                  <strong className="text-[#000000] font-semibold">5.2</strong> What are cookies? <br />
                  Cookies are small text files stored on your device (like your phone or computer) when you visit a website. They don’t harm your device and can’t see your personal information, but they help the website work properly and give you a more personalized experience.
                </p>

                <p className="md:text-[17px] text-[#0000005A] font-semibold mt-[2%]">Types of cookies we use:</p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold marker:text-black">
                  <li>
                    <strong className="text-[#000000] font-semibold">Essential cookies:</strong> These are needed for the site to work (like logging in or making a payment).
                  </li>
                  <li>
                    <strong className="text-[#000000] font-semibold">Performance cookies:</strong> These help us understand how players use the site so we can make it better.
                  </li>
                  <li>
                    <strong className="text-[#000000] font-semibold">Functionality cookies:</strong> These remember your settings, like your language or region.
                  </li>
                  <li>
                    <strong className="text-[#000000] font-semibold">Targeting cookies:</strong> These help us show you more relevant content and may be shared with our advertising partners.
                  </li>
                </ul>
                <p className="md:text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  Some cookies may also be placed by third-party services we use (like analytics or ad networks). We don’t control those cookies, but we aim to work only with trusted partners.
                </p>

                <p className="md:text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  <strong className="text-[#000000] font-semibold">5.3</strong> Controlling cookies:

                  You can control or delete cookies anytime in your browser settings. If you block some cookies, parts of our site might not work properly. Helpful links:
                </p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold marker:text-black">
                  <li>Your Online Choices</li>
                  <li>All About Cookies</li>
                </ul>
                <p className="md:text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  By continuing to use our site, you agree to our use of cookies. Unless required, all non-essential cookies automatically expire after 30 days.
                </p>
                <p className="md:text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  Got questions?
                </p>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  You can contact us at: <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>.
                </p>
                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  6. Data Retention:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">6·1</strong> SportsPik retain your personal information only for as long as necessary to fulfil the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law. The criteria used to determine the appropriate retention period include the duration of your account and our legal obligations.
                </p>

                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  7. User Rights:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">7·1</strong>  You have certain rights regarding your personal data, including the right to access, rectify, delete, or restrict the processing of your information. You may also have the right to data portability and the right to object to processing under certain circumstances.
                </p>
                <p className="md:text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">7·2</strong>  To exercise these rights or for any inquiries regarding your personal data, please contact us using the information provided in the "Contact Us" section below.
                </p>

                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  8. Data Transfer:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">8.1</strong> Your personal data may be transferred to and processed in countries other than your own, where data protection laws may differ. When SportsPik transfers your information to third parties or service providers outside your country, SportsPik takes appropriate safeguards to ensure that your data is adequately protected in accordance with applicable data protection laws.
                </p>

                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  9. Children's Privacy:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">9·1</strong> SportsPik only permits players who are 18 years of age or older. Access to the platform is not granted to children’s and individuals under the age of 18.
                </p>

                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  10. Legal Basis for Processing:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">10.1</strong> SportsPik relies on various legal bases to process your personal data, including consent, contract performance, legitimate interests, and compliance with legal obligations. We may process your information for the purposes stated in this Privacy Policy based on one or more of these legal grounds.
                </p>

                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  11. Data Breach Notification:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">11.1</strong> In the event of a data breach that may compromise the security of your personal information, SportsPik will notify you and the relevant authorities as required by applicable law. We will also take appropriate measures to mitigate the impact of the breach and prevent future incidents.
                </p>
                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  12. Third-Party Links and Services:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">12.1</strong> Our website may contain links to third-party websites or services for your convenience. Please be aware that we are not responsible for the privacy practices or content of these external sites. SportsPik recommends reviewing the privacy policies of these third parties before engaging with their services.
                </p>
                <h4 className="md:text-[22px] mt-[3%] text-[#000000] font-semibold">
                  13. Updates to Privacy Policy:
                </h4>
                <p className="md:text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">13.1</strong> SportsPik reserves the right to update and revise this Privacy Policy as needed to reflect changes in our data practices, legal requirements, or business operations. Any modifications will be communicated to you through our website or via email.
                </p>
              </Card>
            </div>
          </div>

          <MobileFooter />
        </div>
      ) : isTab ? (
        <div className="overflow-auto bg-[url('../public/v2/images/bg/auth-bg.png')] bg-cover h-[100vh] w-full font-Inter">
          <div className="h-[100vh] w-full p-5 font-interFont">
            {!storedUserInfo?.email && (
              <div className="flex w-full px-3 pb-5 items-center justify-between border-b border-[#D3D3D31F] w-[95%] mx-auto">
                <div className="flex-shrink-0">
                  <img 
                    src={pnpLogo} 
                    alt="pickNdPrizes" 
                    onClick={redirectHome}
                    className="h-20 cursor-pointer"
                  />
                </div>
                <div className="laptop-banner:text-[15px] text-[12px] font-[400] font-roboto flex laptop-banner:gap-5 gap-2 items-center flex-shrink-0">
                  <button
                    className="bg-[#00C05B] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[1rem] sm:px-[1.5rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToLogin}
                  >
                    Login
                  </button>

                  <button
                    className="bg-[#007FFF] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[0.75rem] sm:px-[1rem] md:px-[1.15rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToRegister}
                  >
                    Sign Up For Free
                  </button>
                </div>
              </div>
            )}

            <div>
              <div className={`privacy-top ${storedUserInfo?.email ? '' : 'mt-10'}`}>
                <h2 className="text-[#FFFFFF] text-[48px] text-center font-semibold">
                  Privacy & Cookie Policy
                </h2>
              </div>

              {/* <Card className="m-auto h-[62.6vh] font-interFont overflow-auto  pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <p className="text-[17px] mt-[2%] text-[#0000005A] font-semibold">
                  Welcome to SportsPik! We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your data when you interact with our website and services. SportsPik is committed to protecting your privacy policy. Please review the following detailed information about your privacy rights and our data practices.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  1. Information We Collect:
                </h4>
                <p className="text-[17px] mt-[2%] text-[#0000005A] font-semibold">
                  When you create an account on SportsPik, we may collect various types of personal information, including your name, email address, date of birth, payment details, and any other information necessary for account setup and participation in prediction games.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  Additionally, we automatically gather non-personal information such as your IP address, device type, browser information, and cookies to enhance user experience, analyze trends, and ensure the security of our platform.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  2. Use of Your Information:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  2·1 Your personal information is primarily used to manage your account, process payments, facilitate game participation, communicate important messages.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  2.2 Non-personal information is utilised for statistical analysis, website optimization, security monitoring, and customization of content to better meet your preferences and needs.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  3. Data Security Measures:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  3.1 SportsPik implements robust security measures to protect your personal data from unauthorized access, disclosure, alteration, or destruction. Your information is stored securely and accessed only by authorized personnel for legitimate business purposes.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  3·3 All payment transactions are encrypted and processed through reputable payment gateways to ensure the confidentiality and integrity of your financial details.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  4. Sharing of Information:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  4·1 SportsPik do not sell, trade, or rent your personal information to third parties for marketing purposes. However, we may share your data with trusted service providers, partners, or affiliates who assist us in delivering our services, processing payments, or improving user experience.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  4·2 These third parties are contractually obligated to maintain the confidentiality of your information and adhere to data protection regulations.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  5. Use of Cookies and Tracking Technologies:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  5·1 At sportspik.com (“Site”), we use cookies to make your experience seamless when you visit our website. Cookies help us:
                </p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold">
                  <li>Remember who you are when you come back</li>
                  <li>Improve how our site works</li>
                  <li>Make sure everything runs smoothly</li>
                  <li>Show you content that is more relatable to you</li>
                </ul>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  5.2 What are cookies? <br />
                  Cookies are small text files stored on your device (like your phone or computer) when you visit a website. They don’t harm your device and can’t see your personal information, but they help the website work properly and give you a more personalized experience.
                </p>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">Types of cookies we use:</p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold">
                  <li>
                    <strong>Essential cookies:</strong> These are needed for the site to work (like logging in or making a payment).
                  </li>
                  <li>
                    <strong>Performance cookies:</strong> These help us understand how players use the site so we can make it better.
                  </li>
                  <li>
                    <strong>Functionality cookies:</strong> These remember your settings, like your language or region.
                  </li>
                  <li>
                    <strong>Targeting cookies:</strong> These help us show you more relevant content and may be shared with our advertising partners.
                  </li>
                </ul>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  Some cookies may also be placed by third-party services we use (like analytics or ad networks). We don’t control those cookies, but we aim to work only with trusted partners.
                </p>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  5.3 Controlling cookies:

                  You can control or delete cookies anytime in your browser settings. If you block some cookies, parts of our site might not work properly. Helpful links:
                </p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold">
                  <li>Your Online Choices</li>
                  <li>All About Cookies</li>
                </ul>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  By continuing to use our site, you agree to our use of cookies. Unless required, all non-essential cookies automatically expire after 30 days.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  Got questions?
                </p>
                <p>
                  You can contact us at: support@sportspik.com.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  6. Data Retention:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  6·1 SportsPik retain your personal information only for as long as necessary to fulfil the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law. The criteria used to determine the appropriate retention period include the duration of your account and our legal obligations.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  7. User Rights:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  7·1 You have certain rights regarding your personal data, including the right to access, rectify, delete, or restrict the processing of your information. You may also have the right to data portability and the right to object to processing under certain circumstances.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  7·2 To exercise these rights or for any inquiries regarding your personal data, please contact us using the information provided in the "Contact Us" section below.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  8. Data Transfer:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  8·1 Your personal data may be transferred to and processed in countries other than your own, where data protection laws may differ. When SportsPik transfers your information to third parties or service providers outside your country, SportsPik takes appropriate safeguards to ensure that your data is adequately protected in accordance with applicable data protection laws.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  9. Children's Privacy:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  9·1 SportsPik only permits players who are 18 years of age or older. Access to the platform is not granted to children’s and individuals under the age of 18.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  10. Legal Basis for Processing:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  10·1 SportsPik relies on various legal bases to process your personal data, including consent, contract performance, legitimate interests, and compliance with legal obligations. We may process your information for the purposes stated in this Privacy Policy based on one or more of these legal grounds.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  11. Data Breach Notification:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  11·1 In the event of a data breach that may compromise the security of your personal information, SportsPik will notify you and the relevant authorities as required by applicable law. We will also take appropriate measures to mitigate the impact of the breach and prevent future incidents.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  12. Third-Party Links and Services:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  12·1 Our website may contain links to third-party websites or services for your convenience. Please be aware that we are not responsible for the privacy practices or content of these external sites. SportsPik recommends reviewing the privacy policies of these third parties before engaging with their services.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  13. Updates to Privacy & Cookie Policy:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  13·1 SportsPik reserves the right to update and revise this Privacy Policy as needed to reflect changes in our data practices, legal requirements, or business operations. Any modifications will be communicated to you through our website or via email.
                </p>
              </Card> */}
              <Card className="m-auto h-[62.6vh] font-interFont overflow-auto  pl-12 pt-12 pb-12 pr-12 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <p className="text-[17px] mt-[2%] text-[#0000005A] font-semibold">
                  Welcome to SportsPik! We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your data when you interact with our website and services. SportsPik is committed to protecting your privacy policy. Please review the following detailed information about your privacy rights and our data practices.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  1. Information We Collect:
                </h4>
                <p className="text-[17px] mt-[1%] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">1.1</strong> When you create an account on SportsPik, we may collect various types of personal information, including your name, email address, date of birth, payment details, and any other information necessary for account setup and participation in prediction games.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">1.2</strong> Additionally, we automatically gather non-personal information such as your IP address, device type, browser information, and cookies to enhance user experience, analyze trends, and ensure the security of our platform.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  2. Use of Your Information:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">2·1</strong> Your personal information is primarily used to manage your account, process payments, facilitate game participation, communicate important messages.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">2.2</strong> Non-personal information is utilised for statistical analysis, website optimization, security monitoring, and customization of content to better meet your preferences and needs.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  3. Data Security Measures:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">3·1</strong> SportsPik implements robust security measures to protect your personal data from unauthorized access, disclosure, alteration, or destruction. Your information is stored securely and accessed only by authorized personnel for legitimate business purposes.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">3·2</strong> All payment transactions are encrypted and processed through reputable payment gateways to ensure the confidentiality and integrity of your financial details.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  4. Sharing of Information:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4·1</strong> SportsPik do not sell, trade, or rent your personal information to third parties for marketing purposes. However, we may share your data with trusted service providers, partners, or affiliates who assist us in delivering our services, processing payments, or improving user experience.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">4·2</strong> These third parties are contractually obligated to maintain the confidentiality of your information and adhere to data protection regulations.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  5. Use of Cookies and Tracking Technologies:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">5.1</strong> At sportspik.com (“Site”), we use cookies to make your experience seamless when you visit our website. Cookies help us:
                </p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold marker:text-black">
                  <li>Remember who you are when you come back</li>
                  <li>Improve how our site works</li>
                  <li>Make sure everything runs smoothly</li>
                  <li>Show you content that is more relatable to you</li>
                </ul>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%] pt-3">
                  <strong className="text-[#000000] font-semibold">5.2</strong> What are cookies? <br />
                  Cookies are small text files stored on your device (like your phone or computer) when you visit a website. They don’t harm your device and can’t see your personal information, but they help the website work properly and give you a more personalized experience.
                </p>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">Types of cookies we use:</p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold marker:text-black">
                  <li>
                    <strong className="text-[#000000] font-semibold">Essential cookies:</strong> These are needed for the site to work (like logging in or making a payment).
                  </li>
                  <li>
                    <strong className="text-[#000000] font-semibold">Performance cookies:</strong> These help us understand how players use the site so we can make it better.
                  </li>
                  <li>
                    <strong className="text-[#000000] font-semibold">Functionality cookies:</strong> These remember your settings, like your language or region.
                  </li>
                  <li>
                    <strong className="text-[#000000] font-semibold">Targeting cookies:</strong> These help us show you more relevant content and may be shared with our advertising partners.
                  </li>
                </ul>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  Some cookies may also be placed by third-party services we use (like analytics or ad networks). We don’t control those cookies, but we aim to work only with trusted partners.
                </p>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  <strong className="text-[#000000] font-semibold">5.3</strong> Controlling cookies:

                  You can control or delete cookies anytime in your browser settings. If you block some cookies, parts of our site might not work properly. Helpful links:
                </p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold marker:text-black">
                  <li>Your Online Choices</li>
                  <li>All About Cookies</li>
                </ul>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  By continuing to use our site, you agree to our use of cookies. Unless required, all non-essential cookies automatically expire after 30 days.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  Got questions?
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  You can contact us at: <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  6. Data Retention:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">6·1</strong> SportsPik retain your personal information only for as long as necessary to fulfil the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law. The criteria used to determine the appropriate retention period include the duration of your account and our legal obligations.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  7. User Rights:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">7·1</strong>  You have certain rights regarding your personal data, including the right to access, rectify, delete, or restrict the processing of your information. You may also have the right to data portability and the right to object to processing under certain circumstances.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">7·2</strong>  To exercise these rights or for any inquiries regarding your personal data, please contact us using the information provided in the "Contact Us" section below.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  8. Data Transfer:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">8.1</strong> Your personal data may be transferred to and processed in countries other than your own, where data protection laws may differ. When SportsPik transfers your information to third parties or service providers outside your country, SportsPik takes appropriate safeguards to ensure that your data is adequately protected in accordance with applicable data protection laws.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  9. Children's Privacy:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">9·1</strong> SportsPik only permits players who are 18 years of age or older. Access to the platform is not granted to children’s and individuals under the age of 18.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  10. Legal Basis for Processing:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">10.1</strong> SportsPik relies on various legal bases to process your personal data, including consent, contract performance, legitimate interests, and compliance with legal obligations. We may process your information for the purposes stated in this Privacy Policy based on one or more of these legal grounds.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  11. Data Breach Notification:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">11.1</strong> In the event of a data breach that may compromise the security of your personal information, SportsPik will notify you and the relevant authorities as required by applicable law. We will also take appropriate measures to mitigate the impact of the breach and prevent future incidents.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  12. Third-Party Links and Services:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">12.1</strong> Our website may contain links to third-party websites or services for your convenience. Please be aware that we are not responsible for the privacy practices or content of these external sites. SportsPik recommends reviewing the privacy policies of these third parties before engaging with their services.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  13. Updates to Privacy Policy:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">13.1</strong> SportsPik reserves the right to update and revise this Privacy Policy as needed to reflect changes in our data practices, legal requirements, or business operations. Any modifications will be communicated to you through our website or via email.
                </p>
              </Card>
            </div>
          </div>
          <FooterTab componnent="privacyPlolicy" />
        </div>
      ) : (
        <div className="flex flex-col min-h-screen bg-[url('../public/v2/images/bg/auth-bg.png')] bg-cover w-full overflow-auto h-[100vh]">
          <div className="flex-1 p-5 font-Inter">
            {!storedUserInfo?.email && (
              <div className="flex p-3 items-center justify-between border-b border-[#D3D3D31F] w-[95%] mx-auto">
                <div className="flex-shrink-0">
                  <img src={pnpLogo} alt="pickNdPrizes" onClick={redirectHome} className="h-20 cursor-pointer"></img>
                </div>
                <div className="laptop-banner:text-[15px] text-[12px] font-[400] font-roboto flex laptop-banner:gap-5 gap-2 items-center flex-shrink-0">
                  <button
                    className="bg-[#00C05B] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[1rem] sm:px-[1.5rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToLogin}
                  >
                    Login
                  </button>

                  <button
                    className="bg-[#007FFF] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[0.75rem] sm:px-[1rem] md:px-[1.15rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                    onClick={redirectToRegister}
                  >
                    Sign Up For Free
                  </button>
                </div>
              </div>
            )}

            <div>
              <div className={`privacy-top ${storedUserInfo?.email ? 'mt-14' : 'mt-10'}`}>
                <h2 className="text-[#FFFFFF] text-[48px] text-center font-semibold">
                  Privacy & Cookie Policy
                </h2>
              </div>

              <Card className="m-auto h-[70vh] overflow-auto  pl-24 pt-12 pb-12 pr-24 flex flex-col justify-between w-[95%] my-[2%] bg-[#FFFFFF] shadow-md rounded-[12px] relative">
                <p className="text-[17px] mt-[2%] text-[#0000005A] font-semibold">
                  Welcome to SportsPik! We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your data when you interact with our website and services. SportsPik is committed to protecting your privacy policy. Please review the following detailed information about your privacy rights and our data practices.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  1. Information We Collect:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">1.1</strong> When you create an account on SportsPik, we may collect various types of personal information, including your name, email address, date of birth, payment details, and any other information necessary for account setup and participation in prediction games.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">1.2</strong> Additionally, we automatically gather non-personal information such as your IP address, device type, browser information, and cookies to enhance user experience, analyze trends, and ensure the security of our platform.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  2. Use of Your Information:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">2·1</strong> Your personal information is primarily used to manage your account, process payments, facilitate game participation, communicate important messages.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">2.2</strong> Non-personal information is utilised for statistical analysis, website optimization, security monitoring, and customization of content to better meet your preferences and needs.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  3. Data Security Measures:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">3·1</strong> SportsPik implements robust security measures to protect your personal data from unauthorized access, disclosure, alteration, or destruction. Your information is stored securely and accessed only by authorized personnel for legitimate business purposes.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">3·2</strong> All payment transactions are encrypted and processed through reputable payment gateways to ensure the confidentiality and integrity of your financial details.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  4. Sharing of Information:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">4·1</strong> SportsPik do not sell, trade, or rent your personal information to third parties for marketing purposes. However, we may share your data with trusted service providers, partners, or affiliates who assist us in delivering our services, processing payments, or improving user experience.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">4·2</strong> These third parties are contractually obligated to maintain the confidentiality of your information and adhere to data protection regulations.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  5. Use of Cookies and Tracking Technologies:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">5.1</strong> At sportspik.com (“Site”), we use cookies to make your experience seamless when you visit our website. Cookies help us:
                </p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold marker:text-black">
                  <li>Remember who you are when you come back</li>
                  <li>Improve how our site works</li>
                  <li>Make sure everything runs smoothly</li>
                  <li>Show you content that is more relatable to you</li>
                </ul>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%] pt-3">
                  <strong className="text-[#000000] font-semibold">5.2</strong> What are cookies? <br />
                  Cookies are small text files stored on your device (like your phone or computer) when you visit a website. They don’t harm your device and can’t see your personal information, but they help the website work properly and give you a more personalized experience.
                </p>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">Types of cookies we use:</p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold marker:text-black">
                  <li>
                    <strong className="text-[#000000] font-semibold">Essential cookies:</strong> These are needed for the site to work (like logging in or making a payment).
                  </li>
                  <li>
                    <strong className="text-[#000000] font-semibold">Performance cookies:</strong> These help us understand how players use the site so we can make it better.
                  </li>
                  <li>
                    <strong className="text-[#000000] font-semibold">Functionality cookies:</strong> These remember your settings, like your language or region.
                  </li>
                  <li>
                    <strong className="text-[#000000] font-semibold">Targeting cookies:</strong> These help us show you more relevant content and may be shared with our advertising partners.
                  </li>
                </ul>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  Some cookies may also be placed by third-party services we use (like analytics or ad networks). We don’t control those cookies, but we aim to work only with trusted partners.
                </p>

                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  <strong className="text-[#000000] font-semibold">5.3</strong> Controlling cookies:

                  You can control or delete cookies anytime in your browser settings. If you block some cookies, parts of our site might not work properly. Helpful links:
                </p>
                <ul className="list-disc pl-6 text-[17px] text-[#0000005A] font-semibold marker:text-black">
                  <li>Your Online Choices</li>
                  <li>All About Cookies</li>
                </ul>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  By continuing to use our site, you agree to our use of cookies. Unless required, all non-essential cookies automatically expire after 30 days.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold mt-[2%]">
                  Got questions?
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  You can contact us at: <a href="mailto:support@sportspik.com" class="text-blue-600 underline">support@sportspik.com</a>.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  6. Data Retention:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">6·1</strong> SportsPik retain your personal information only for as long as necessary to fulfil the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law. The criteria used to determine the appropriate retention period include the duration of your account and our legal obligations.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  7. User Rights:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">7·1</strong>  You have certain rights regarding your personal data, including the right to access, rectify, delete, or restrict the processing of your information. You may also have the right to data portability and the right to object to processing under certain circumstances.
                </p>
                <p className="text-[17px] text-[#0000005A] font-semibold pt-3">
                  <strong className="text-[#000000] font-semibold">7·2</strong>  To exercise these rights or for any inquiries regarding your personal data, please contact us using the information provided in the "Contact Us" section below.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  8. Data Transfer:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">8.1</strong> Your personal data may be transferred to and processed in countries other than your own, where data protection laws may differ. When SportsPik transfers your information to third parties or service providers outside your country, SportsPik takes appropriate safeguards to ensure that your data is adequately protected in accordance with applicable data protection laws.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  9. Children's Privacy:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">9·1</strong> SportsPik only permits players who are 18 years of age or older. Access to the platform is not granted to children’s and individuals under the age of 18.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  10. Legal Basis for Processing:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">10.1</strong> SportsPik relies on various legal bases to process your personal data, including consent, contract performance, legitimate interests, and compliance with legal obligations. We may process your information for the purposes stated in this Privacy Policy based on one or more of these legal grounds.
                </p>

                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  11. Data Breach Notification:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">11.1</strong> In the event of a data breach that may compromise the security of your personal information, SportsPik will notify you and the relevant authorities as required by applicable law. We will also take appropriate measures to mitigate the impact of the breach and prevent future incidents.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  12. Third-Party Links and Services:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">12.1</strong> Our website may contain links to third-party websites or services for your convenience. Please be aware that we are not responsible for the privacy practices or content of these external sites. SportsPik recommends reviewing the privacy policies of these third parties before engaging with their services.
                </p>
                <h4 className="text-[22px] mt-[3%] text-[#000000] font-semibold">
                  13. Updates to Privacy Policy:
                </h4>
                <p className="text-[17px] text-[#0000005A] font-semibold">
                  <strong className="text-[#000000] font-semibold">13.1</strong> SportsPik reserves the right to update and revise this Privacy Policy as needed to reflect changes in our data practices, legal requirements, or business operations. Any modifications will be communicated to you through our website or via email.
                </p>
              </Card>
            </div>
          </div>

          <>
            {/* For small devices */}
            <MobileFooter />

            {/* For tablet */}
            <FooterTab componnent="rules" />

            {/* For laptop and larger */}
            <Footer componnent="rules" />
          </>
        </div>
      )}
    </>
  );
}

export default PrivacyPolicy;
